export function executeGraphQlQuery(key, query, variables) {
  return fetch(`${window.Shopify.routes.root}api/2025-10/graphql.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': key,
    },
    body: JSON.stringify({
      query,
      variables,
    }),
  }).then((res) => res.json())
}
